import React from 'react'
import TextScroll from '../components/TextScroll'

const DynamicTextscroll = () => {
    const messages = [
        'Attract the best talent, integrate them seamlessly into your operations, and provide them with the compensation they deserve. Our platform is designed to help you recruit, manage, and pay your team with ease, ensuring a smooth experience from start to finish'];
  return (
    <div>
    <TextScroll textItems={messages} speed={30} direction="left" />
    </div>
  )
}

export default DynamicTextscroll